import React from "react";
import Styles from './styles.module.scss'

import Seo from "../../components/_UI/seo";
import {useTranslation} from "react-i18next";
import AuthRedirect from "../../components/authRedirect";



const CabinetTransfersPage = () => {
    const { t } = useTranslation();

    return (
        <section className={`${Styles.container}`}>
            <Seo title={t('Переводы')}/>
            <AuthRedirect isCabinet={true}/>
            <div>{t('Переводы')}</div>
        </section>
    );
};

export default CabinetTransfersPage;